import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from '../../api';
import helpers from '../../helpers'



class MoviePosterImage extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    movie: PropTypes.any,
    movieId: PropTypes.any,
    posterMediaId: PropTypes.any,
    resolutionSize: PropTypes.any,
  };

  static defaultProps = {
    movie: null,
    movieId: null,
    posterMediaId: null,
    resolutionSize: '500x500',
  };

  constructor(props) {
    super(props);

    this.movieHelper = helpers.movie;

    this.onImgLoaded = this.onImgLoaded.bind(this);
    this.onImgError = this.onImgError.bind(this);

    this.state = _.extend({
      loaded: true,
      imgLoaded: false,
      imgLoadSuccess: false,
      // movie: props.movie,
      // movieId: props.movieId,
      // posterMediaId: props.posterMediaId,
      posterUrl: null
    }, this._preparePropsState());

    // setTimeout(() => this.invalidatePropsState, 0);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    // compare specific props and watch for changes.
    // if any of those props change, then update them in state
    let newState = this._preparePropsState();
    if (newState.posterUrl !== prevState.posterUrl) {
      this.setState(newState);
    }

    /*
    // compare specific props and watch for changes.
    // if any of those props change, then update them in state
    let cmpProps = ['movie', 'movieId', 'posterMediaId'];
    let cmpCurr = _.picK(this.props, cmpProps);
    let cmpPrev = _.pick(prevProps, cmpProps);
    if (!_.isEqual(cmpCurr, cmpPrev)) {
      let state = this._preparePropsState();
      this.setState(state);
    }
    //*/
  }

  invalidatePropsState() {
    let state = this._preparePropsState();
    this.setState(state);
  }

  _preparePropsState() {
    let posterUrl = null;
    let posterParams = this.props.resolutionSize? { res: this.props.resolutionSize }: null;
    if (this.props.movie) {
      posterUrl = api.movies.getPosterUrlFromMovie(this.props.movie, posterParams);
    } else if (this.props.movieId) {
      posterUrl = api.movies.getPosterUrlFromMovieId(this.props.movieId, this.props.posterMediaId, posterParams);
    } else if (this.props.posterMediaId) {
      posterUrl = api.movies.getPosterUrlFromPosterMediaId(this.props.posterMediaId, posterParams);
    }

    return { imgLoaded: false, imgLoadSuccess: false, posterUrl };
  }

  onImgLoaded(url) {
    if (!url || this.state.posterUrl !== url) { return; }
    this.setState({ imgLoaded: true, imgLoadSuccess: true });
  }

  onImgError(url) {
    if (!url || this.state.posterUrl !== url) { return; }
    this.setState({ imgLoaded: true, imgLoadSuccess: false });
  }

  render() {

    let posterUrl = this.state.posterUrl;
    let missingImage = !posterUrl || (this.state.imgLoaded && !this.state.imgLoadSuccess);
    let classes = '';
    if (this.props.className) { classes += this.props.className + ' '; }
    classes += 'movie-poster-image poster-image';
    if (missingImage) { classes += ' missing-image'; }

    return (
      <div className={classes}>
        <img src={posterUrl} alt="" onLoad={() => this.onImgLoaded(posterUrl)} onError={() => this.onImgError(posterUrl)} />
      </div>
    );
  }
}

export default MoviePosterImage;

